import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import type { CmApi, OrganizationDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';
import { toViewModel } from './toViewModel';
import type { OrganizationView} from './toViewModel';

class OrganizationsStore {
  organizations: OrganizationDto[] = [];

  headOrganizations: OrganizationDto[] = [];

  api: CmApi;

  isChanged = false;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  get viewModel(): OrganizationView[] | undefined {
    return toViewModel(this.organizations);
  }

  setIsChanged = () => {
    this.isChanged = true;
  };

  fetch = async (signal?: AbortSignal): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.organizations.getOrganizations({ signal });

    runInAction(() => {
      const organizationsWithId = data?.map((org) => ({ ...org, id: org.code })) ?? [];
      this.organizations = organizationsWithId;
      this.headOrganizations = organizationsWithId.length ? organizationsWithId.filter((el) => el.head) : [];
      this.isChanged = false;
    });
    preloaderStore.preloader(false);
  };

  clear = () => {
    this.organizations = [];
  };
}

export const organizationsStore = new OrganizationsStore({ api: cmApi });
